import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import LoginAuthenticator from "./component";

const mapStateToProps = ({
    user: {
        currentPageType
    }
}) => ({
    currentPageType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LoginAuthenticator);
